module.exports = __webpack_public_path__ + "media/pages/book/components/images/main-features/growing-33e0c0243d100bf216d2866f4bc325ae.svg";